import React from 'react';
import Tooltip from '../common/Tooltip';
import CircularProgress from '@mui/joy/CircularProgress';
import PhoneIcon from '@mui/icons-material/Phone';
import PhoneInTalkIcon from '@mui/icons-material/PhoneInTalk';
import SpeakerPhoneIcon from '@mui/icons-material/SpeakerPhone';
import SplitButton from '../common/SplitButton';


export default function AgentButton({ hasTelephony, hasWebRTC, tooltip, state, onClick, ...rest }) {
  let options = [];
  
  if (state === 'initial') {
    hasWebRTC && options.push({
      startDecorator: <SpeakerPhoneIcon />,
      label: 'Talk to Agent',
      onClick: () => {
        console.log(`start WebRTC`);
        onClick('webrtc');
      }
    });
    hasTelephony && options.push({
      startDecorator: <PhoneIcon />,
      label: 'Telephone Agent',
      onClick: () => {
        console.log('start Inbound Call');
        onClick('inbound-call');
      }
    });
    hasTelephony && options.push({
      startDecorator: <PhoneInTalkIcon />,
      label: 'Agent Call Me',
      onClick: () => {
        console.log('start Outbound Call');
        onClick('outbound-call');
      }
    });
    !options.length && options.push({ startDecorator: <SpeakerPhoneIcon />, label: 'Talk to Agent', onClick: () => onClick('webrtc') });
  } else if (state === 'trying') {
    options.push({ startDecorator: <CircularProgress thickness={2} /> });
  } else if (state === 'active') {
    options.push({ label: 'Update Agent', onClick: () => onClick(null) });
  }

  console.log({ options, hasTelephony, hasWebRTC }, 'agent button');

  return (
    <Tooltip {...{ tooltip }} open={!!tooltip}>
      <SplitButton
        {...rest}
        options={options}
      />
    </Tooltip>
  );
};